export const BUTTON_TYPE = 'button';
